import { designService } from '@paragon/data-connections';
import { enqueueError } from '@paragon/notification-tools';

import { trailersLoaded } from '../store/trailersSlice';
import { AsyncThunkActionVoid } from './thunkActions';

export function loadTrailers(): AsyncThunkActionVoid {
  return async function loadTrailersThunkAction(dispatch) {
    try {
      const trailers = await designService.trailers.getAll();
      dispatch(trailersLoaded(trailers));
    } catch (exception) {
      console.error(exception);
      dispatch(enqueueError('Loading trailers failed. Try refreshing or contact Paragon support.'));
    }
  };
}
